import React from "react";
import { Box } from "@mui/material";
import Header from "../shared/header";
import LoginForm from "../shared/forms/login-account";

/**
 * Login Page component that provides a form for users to authenticate into the application.
 * The page displays a centered layout with a header and the login form.
 * 
 * @component
 * @returns {JSX.Element} A centered box containing the login UI
 * 
 * @example
 * ```tsx
 * <LoginPage />
 * ```
 */
const LoginPage = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh" /* Adjust the height as needed */
    >
      <Box width="60%" m="20px">
        <Box textAlign="center">
          <Header
            showLogo
            subtitle="E-Mail und Passwort zur Anmeldung verwenden"
          />
        </Box>
        <LoginForm />
      </Box>
    </Box>
  );
};

export default LoginPage;
